
import getPages from 'utils/getPages'

const getCurrentPage = async (curLoc: any) => {
    
    const curBasepath = '/' + curLoc.pathname.split('/')[1]
    const pages: any = await getPages()
    const curPage = pages.find(item => {
        if (typeof item.path === 'string')
            return '/' + item.path.split('/')[1] === curBasepath
        else 
            return false
    })

    return curPage ?? null
}

export default getCurrentPage